import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import user from "../public/assets/img/user.png";
import { toast, ToastContainer } from "react-toastify";
import Breadcrumb from "../Breadcrumb";


const Staff = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [userData, setUserData] = useState({
    id: "",
    name: "",
    email: "",
    profileImage: "",
    image: null,
    role_id: "",
    mobile_number: "",
    address: "",
    password: "",
    confirm_password: "",
    start_date: "",
    end_date: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const fileInputRef = useRef(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/";
  const token = localStorage.getItem("token");


  useEffect(() => {
    if (id) {
      const fetchUser = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}get-user-by-id/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
          });

          const userDetails = response.data.user;

          setUserData((prevData) => ({
            ...prevData,
            id: userDetails.id,
            name: userDetails.name,
            email: userDetails.email,
            profileImage: userDetails.image_url || "",
            role_id: userDetails.role_id,
            mobile_number: userDetails.mobile_number || "",
            address: userDetails.address || "",
            start_date: userDetails.start_date || "",
            end_date: userDetails.end_date || "",
          }));

          setLoading(false);
        } catch (error) {
          console.error("Error fetching user:", error);
          setLoading(false);
        }
      };
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: undefined,
    }));
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setUserData((prevData) => ({
        ...prevData,
        image: file,
        profileImage: URL.createObjectURL(file),
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!userData.name.trim()) newErrors.name = "Full name is required.";
    if (!userData.role_id) newErrors.role_id = "Role is required.";
    if (!userData.start_date) newErrors.start_date = "Subscription start date is required.";
    if (!userData.end_date) newErrors.end_date = "Subscription End date is required.";
    if (!userData.password.trim()) newErrors.password = "Password is required.";
    if (!userData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
      newErrors.email = "Invalid email format.";
    }


    if (!userData.confirm_password.trim()) newErrors.confirm_password = "Confirm password is required.";
    if (!userData.mobile_number.trim()) {
      newErrors.mobile_number = "Phone number is required.";
    } if (!/^\d+$/.test(userData.mobile_number)) {
      newErrors.mobile_number = "Only numbers are allowed";
    } if (userData.mobile_number.length !== 10) {
      newErrors.mobile_number = "Phone number must be exactly 10 digits";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    try {
      const formData = new FormData();

      formData.append('name', userData.name);
      formData.append('email', userData.email);
      formData.append('role_id', userData.role_id);
      if (userData.password) {
        formData.append('password', userData.password);
        formData.append('confirm_password', userData.confirm_password);
      }
      formData.append('start_date', userData.start_date);
      formData.append('end_date', userData.end_date);

      formData.append('details_json', JSON.stringify({
        mobile_number: userData.mobile_number,
        address: userData.address
      }));


      if (userData.image) {
        formData.append('image', userData.image);
      }

      let response;
      if (id) {

        response = await axios.put(`${API_BASE_URL}update-user/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      } else {

        response = await axios.post(`${API_BASE_URL}add-user`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });
      }

      if (response.data.status === "success") {
        // toast.success(id ? "Staff updated successfully" : "Staff added successfully");
        const roleText = userData.role_id === "2" ? "Affiliate" : "Staff";
        toast.success(id ? `${roleText} updated successfully` : `${roleText} added successfully`);

        setTimeout(() => {
          navigate(`/staff`);
        }, 1000);
      } else {
        throw new Error(response.data.message || (id ? "Failed to update staff" : "Failed to add staff"));
      }
    } catch (error) {
      console.error("Error:", error);

      const backendErrors = error.response?.data?.args?.[0];

      if (backendErrors) {
        const formattedErrors = {};


        for (const key in backendErrors) {
          if (Array.isArray(backendErrors[key])) {
            formattedErrors[key] = backendErrors[key][0];
          }
        }


        if (backendErrors._schema && Array.isArray(backendErrors._schema)) {
          formattedErrors.confirm_password = backendErrors._schema[0];
        }

        setErrors(formattedErrors);
      }

      toast.error(error.response?.data?.message || (id ? "Failed to update staff" : "Failed to add staff"));
    }


  };

  const routes = [
    { name: "Home", path: "/dashboard" },
    { name: "Staff", path: "/staff" },
    { name: id ? "Update" : "Create", path: id ? `/staff/update/${id}` : "/staff/create" },
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  return (

    <div class="container-fluid mx-auto">
      <div className="staff-create-page">
        <div className="form-content">
          <ToastContainer />
          <Breadcrumb routes={routes}></Breadcrumb>
          <form onSubmit={handleSubmit}>
            <div className="form-details">
              <div className="d-flex flex-column w-100">
                <div className="form-group form-label img-align my-3 d-flex flex-column">
                  <label htmlFor="inputProfilePicture">Profile Image:</label>
                  <input
                    type="file"
                    className="form-control form-border"
                    id="inputProfilePicture"
                    name="img"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleImageUpload}
                  />
                  <div onClick={() => fileInputRef.current.click()} className="ps-0 form-selected-image">
                    {userData.profileImage ? (
                      <div className="user-img position-relative mx-auto">
                        <img
                          src={userData.profileImage}
                          alt="Profile"
                          style={{
                            width: "110px",
                            height: "110px",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                        <div className="fa-icon-pen">
                          <i className="fa-solid fa-pen"></i>
                        </div>
                      </div>
                    ) : (
                      <div className="image-upload ps-0">
                        <div className="user-img position-relative">
                          <img src={user} alt="Default User" />
                          <div className="fa-icon-pen">
                            <i className="fa-solid fa-pen"></i>
                          </div>
                        </div>
                      </div>
                    )}

                  </div>
                </div>

                <div className="form-group form-label my-3">
                  <label>Full Name:<span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className="form-control form-setting"
                    name="name"
                    value={userData.name}
                    onChange={handleInputChange}
                  />
                  {errors.name && <small className="text-danger">{errors.name}</small>}
                </div>

                <div className="form-group form-label my-3">
                  <label>Email:<span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className="form-control form-setting"
                    name="email"
                    value={userData.email}
                    onChange={handleInputChange}
                    disabled={!!id}
                  />
                  {errors.email && <small className="text-danger">{errors.email}</small>}
                </div>

                <div className="form-group form-label my-3">
                  <label>Phone Number:<span className="text-danger">*</span></label>
                  <input
                    type="tel"
                    className="form-control form-setting"
                    name="mobile_number"
                    value={userData.mobile_number}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        handleInputChange(e);
                      }
                    }}
                    maxLength="10"
                  />
                  {errors.mobile_number && <small className="text-danger">{errors.mobile_number}</small>}
                </div>

                <div className="form-group form-label my-3">
                  <label>Address:</label>
                  <input
                    type="text"
                    className="form-control form-setting"
                    name="address"
                    value={userData.address}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="form-group form-label my-3">
                  <label>Role:<span className="text-danger">*</span></label>
                  <select
                    className="form-control form-setting"
                    name="role_id"
                    value={userData.role_id}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Role</option>
                    <option value="2">Affiliate</option>
                    <option value="3">Staff</option>
                  </select>
                  {errors.role_id && <small className="text-danger">{errors.role_id}</small>}
                </div>

                <div className="form-group form-label my-3">
                  <label>Password:<span className="text-danger">*</span></label>
                  <input
                    type="password"
                    className="form-control form-setting"
                    name="password"
                    value={userData.password}
                    onChange={handleInputChange}
                  />
                  {errors.password && <small className="text-danger">{errors.password}</small>}
                </div>

                <div className="form-group form-label my-3">
                  <label>Confirm Password:<span className="text-danger">*</span></label>
                  <input
                    type="password"
                    className="form-control form-setting"
                    name="confirm_password"
                    value={userData.confirm_password}
                    onChange={handleInputChange}
                  />
                  {errors.confirm_password && <small className="text-danger">{errors.confirm_password}</small>}
                </div>

                <div className="form-group form-label my-3">
                  <label>Subscription Start Date:<span className="text-danger">*</span></label>
                  <input
                    type="date"
                    className="form-control form-setting"
                    name="start_date"
                    value={userData.start_date}
                    onChange={handleInputChange}
                  />
                  {errors.start_date && <small className="text-danger">{errors.start_date}</small>}
                </div>

                <div className="form-group form-label my-3">
                  <label>Subscription End Date:<span className="text-danger">*</span></label>
                  <input
                    type="date"
                    className="form-control form-setting"
                    name="end_date"
                    value={userData.end_date}
                    onChange={handleInputChange}
                  />
                  {errors.end_date && <small className="text-danger">{errors.end_date}</small>}
                </div>

                <div className="form-group form-btns mt-3">
                  <button className="btn btn-primary">
                    {id ? "Update" : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

  );
};

export default Staff;
